import { CSSProperties } from "react";
import { IonTextarea } from "@ionic/react";
import { Asterisk, Colors } from "swing-components";

import style from "./TextAreaInput.module.css";

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  } as CSSProperties,
  label: {
    fontWeight: 600,
    color: Colors.black,
  } as CSSProperties,
  inputWrapper: ({ isDisabled }: Pick<TextAreaInputProps, "isDisabled">) =>
    ({
      borderBottom: `1px solid ${isDisabled ? "transparent" : Colors.slate200}`,
    }) as CSSProperties,
  nativeInput: ({ isDisabled }: Pick<TextAreaInputProps, "isDisabled">) =>
    ({
      padding: 0,
      border: 0,
      width: "100%",
      maxWidth: "100%",
      maxHeight: "100%",
      color: isDisabled ? Colors.slate400 : Colors.black,
      background: "transparent",
      outline: "none",
      appearance: "none",
      touchAction: "manipulation",
      resize: "none",
    }) as CSSProperties,
};

type TextAreaInputProps = {
  label?: string;
  value?: string;
  placeholder?: string;
  isDisabled?: boolean;
  isRequired?: boolean;
  onChange: (value: string) => void;
};

export function TextAreaInput(props: TextAreaInputProps) {
  const { value, label, placeholder, onChange, isDisabled, isRequired = false } = props;

  /***** Constants *****/
  // Defaulting to am empty string to remove `controlled` input error.
  const _value = value || "";

  /***** Render *****/
  return (
    <label style={styles.container}>
      {label && (
        <div style={styles.label}>
          {label}
          {isRequired && <Asterisk />}
        </div>
      )}
      <div style={styles.inputWrapper({ isDisabled })}>
        <IonTextarea
          className={style.placeHolderText}
          disabled={isDisabled}
          autoCapitalize="off"
          autoCorrect="off"
          spellCheck={false}
          aria-label={label}
          placeholder={placeholder}
          value={_value}
          onIonInput={(e) => onChange(e?.target?.value || "")}
          autoGrow
        />
      </div>
    </label>
  );
}
